import { useCallback, useEffect, useState } from "react";
import { PageItem } from "~/features/chat/hooks/useDocList";
import { useDocumentSearchParams } from "~/hooks/useDocumentSearchParams";

type UsePageNavigationProps = {
  pageItems: PageItem[];
};

export const usePageNavigation = ({ pageItems }: UsePageNavigationProps) => {
  const [searchParams, updateSearchParams] = useDocumentSearchParams();
  const [currentPageNumber, setCurrentPageNumberState] = useState<number>(1);
  const currentTab = searchParams.tab;

  const pageNumberFromParams = useCallback((): {
    pageNumber: number;
    found: boolean;
  } => {
    if (searchParams.pageId) {
      const pageIndex = pageItems.findIndex(
        (p) => p.pageId === searchParams.pageId
      );
      if (pageIndex !== -1) {
        return { pageNumber: pageIndex + 1, found: true };
      }
    }

    if (!searchParams.pageId && searchParams.sectionId) {
      const sectionPageIndex = pageItems.findIndex(
        (p) => p.sectionId === searchParams.sectionId
      );
      if (sectionPageIndex !== -1) {
        return { pageNumber: sectionPageIndex + 1, found: true };
      }
    }

    return { pageNumber: 1, found: false };
  }, [searchParams, pageItems]);

  useEffect(() => {
    const { pageNumber, found } = pageNumberFromParams();

    if (found) {
      setCurrentPageNumberState(pageNumber);
    }
  }, [pageNumberFromParams, searchParams]);

  const setCurrentPageNumber = useCallback(
    (pageNumber: number) => {
      const targetPage = pageItems[pageNumber - 1];
      if (targetPage?.pageId && currentTab !== "summary") {
        updateSearchParams({ pageId: targetPage.pageId, sectionId: null });
      }
    },
    [pageItems, updateSearchParams, currentTab]
  );

  return {
    currentPageNumber,
    setCurrentPageNumber,
  };
};
